import styled from "styled-components"

export const LoadingWrapper = styled.div`
    .loading_main {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0,0,0,70%);
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        z-index: 9999;
    }
    .loading_icon {
        p {
            margin: 0;
            color: #3194ff;
            margin-left: -12px;
        }
    }

`
